export function voyageAnchorMenuHandler(
  anchorMenuWrapper,
  anchorMenu,
  anchorElements,
  mainMenu,
  voyageMenu
) {
  const anchorMenuWrapperY = anchorMenuWrapper.getBoundingClientRect().y
  const anchorMenuY = anchorMenu.getBoundingClientRect().y
  const styles = anchorMenu.style
  var mainMenuHeight =
    (mainMenu ? mainMenu.getBoundingClientRect().height : 0) +
    (voyageMenu ? voyageMenu.parentElement.getBoundingClientRect().height : 0)
  if (anchorMenuWrapperY <= mainMenuHeight) {
    styles.position = "fixed"
    styles.top = mainMenuHeight + "px"
    styles.backgroundColor = "#fff"
    removeOverLappedPosition(anchorMenuWrapper)
  }

  if (anchorMenuWrapperY > mainMenuHeight) {
    styles.position = "static"
    styles.width = "100%"
    styles.left = 0
    styles.backgroundColor = "transparent"
    setOverLappedPosition(anchorMenuWrapper)
  }

  var index = Array.from(anchorElements).findIndex(function (element) {
    return (
      element &&
      element.anchorElement &&
      element.anchorElement.hasAttribute("data-byPassOnCroll")
    )
  })
  if (index > -1) {
    anchorElements[index].anchorElement.removeAttribute("data-byPassOnCroll")
    return
  }
  Array.from(anchorElements, function (element) {
    if (element && element.anchorElement && element.targetElement) {
      if (
        element.anchorElement.getBoundingClientRect().y >=
        element.targetElement.getBoundingClientRect().y
      ) {
        element.anchorElement.setAttribute("data-selected", "true")
        Array.from(anchorElements, function (element2) {
          if (element.anchorElement.href !== element2.anchorElement.href) {
            element2.anchorElement.setAttribute("data-selected", "false")
          }
        })
      }
    }
  })
}

export function voyageMenuHandler(mainMenu, voyageMenu, inpageNaviWrapper) {
  if (!voyageMenu) return

  const voyageMenuY = voyageMenu.getBoundingClientRect().y
  const voyageMenuWrapperY = voyageMenu.parentElement.getBoundingClientRect().y
  var mainMenuHeight = mainMenu ? mainMenu.getBoundingClientRect().height : 0

  if (voyageMenuWrapperY <= mainMenuHeight) {
    voyageMenu.style.position = "fixed"
    voyageMenu.style.top = mainMenuHeight + "px"
    voyageMenu.classList.add("animation")
    if (inpageNaviWrapper) voyageMenu.parentElement.classList.add("animated")
  }

  if (voyageMenuWrapperY >= mainMenuHeight) {
    voyageMenu.style.position = "static"
    voyageMenu.classList.remove("animation")
    if (inpageNaviWrapper) voyageMenu.parentElement.classList.remove("animated")
  }
}

export function addEventListeners() {
  try {
    const mainMenu = document.querySelector(".header-one")
    const voyageMenu = document.querySelector(".voyage-subnavi")
    var inpageNaviWrapper = document.querySelector(
      "[data-anchor-menu], [data-anchor-menu-no-filter]"
    )

    voyageMenuHandler(mainMenu, voyageMenu, inpageNaviWrapper)

    window.addEventListener("resize", function () {
      voyageMenuHandler(mainMenu, voyageMenu, inpageNaviWrapper)
    })
    window.addEventListener("scroll", function () {
      voyageMenuHandler(mainMenu, voyageMenu, inpageNaviWrapper)
    })

    const anchorMenuWrapper = document.querySelector(
      "[data-anchor-menu-wrapper]"
    )
    const anchorMenu = anchorMenuWrapper.querySelectorAll(
      "[data-anchor-menu], [data-anchor-menu-no-filter]"
    )

    if (!anchorMenuWrapper || !anchorMenu || anchorMenu.length === 0) return

    var anchors = anchorMenu[0].querySelectorAll(".voyage__navigation-item")
    var anchorElements = Array.from(anchors, function (a) {
      a.addEventListener("click", function () {
        anchorOn(a.id)
      })

      var hash = a.href.split("#").pop()

      var targetElement = document.getElementById(hash)
      if (targetElement) {
        return { anchorElement: a, targetElement: targetElement }
      }
    })

    if (voyageMenu) {
      voyageMenu.addEventListener("transitionend", () => {
        calculateOverlappedPosition(anchorMenuWrapper)
        setOverLappedPosition(anchorMenuWrapper)
      })
    } else {
      calculateOverlappedPosition(anchorMenuWrapper)
      setOverLappedPosition(anchorMenuWrapper)
    }
    onloadInpageNaviPosition()

    window.addEventListener("resize", function () {
      calculateOverlappedPosition(anchorMenuWrapper)
      voyageAnchorMenuHandler(
        anchorMenuWrapper,
        anchorMenu[0],
        anchorElements,
        mainMenu,
        voyageMenu
      )
    })
    window.addEventListener("scroll", function () {
      voyageAnchorMenuHandler(
        anchorMenuWrapper,
        anchorMenu[0],
        anchorElements,
        mainMenu,
        voyageMenu
      )
    })
  } catch (error) {}
}

function anchorOn(classOn) {
  var anchorClass = document.querySelectorAll(".voyage__navigation-item"),
    i
  for (i = 0; i < anchorClass.length; ++i) {
    anchorClass[i].setAttribute("data-selected", "false")
  }

  var anchor = document.getElementById(classOn)
  if (anchor) {
    anchor.setAttribute("data-selected", "true")
    anchor.setAttribute("data-byPassOnCroll", "true")
  }
}

function calculateOverlappedPosition(anchorElement, log) {
  var overLappedTarget = document.getElementsByClassName(
    "voyage__hero-with-info"
  )
  if (
    !overLappedTarget ||
    !overLappedTarget.length ||
    !anchorElement.classList.contains("overLapped") ||
    getBrowserWidth() <= 739
  ) {
    anchorElement.setAttribute("data-overLappedHeight", 0)
    anchorElement.style.position = "static"
    anchorElement.classList.add("overLapped-on-mobile")
    return 0
  }
  var overLappedHeight =
    window.pageYOffset +
    overLappedTarget[0].getBoundingClientRect().bottom -
    anchorElement.getBoundingClientRect().height -
    recursiveBottomPadding(80) // last value is margin to image bottom
  anchorElement.setAttribute("data-overLappedHeight", overLappedHeight)
  return overLappedHeight
}

function setOverLappedPosition(anchorElement) {
  var value = anchorElement.getAttribute("data-overLappedHeight") * 1 || 0
  if (value) {
    anchorElement.style.position = "absolute"
    anchorElement.style.top = value + "px"
    anchorElement.style.backgroundColor = "transparent"
    anchorElement.classList.remove("isFixed")
  }
}

function removeOverLappedPosition(anchorElement) {
  var value = anchorElement.getAttribute("data-overLappedHeight") * 1 || 0
  if (value) {
    anchorElement.classList.add("isFixed")
  }
}

function getBrowserWidth() {
  return (
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth
  )
}

function recursiveBottomPadding(value) {
  if (getBrowserWidth() <= 1023) {
    return value
  }
  if (getBrowserWidth() <= 1400) {
    return value * (getBrowserWidth() / 1400)
  } else return value
}

function onloadInpageNaviPosition() {
  var container = document.querySelector("nav.voyage__navigation--desktop")
  if (!container) return
  Array.from(container.children, (a) => {
    a.addEventListener("click", function () {
      setInpageNaviPosition.call(this, "")
    })
  })
  var hash = location.hash
  if (hash) {
    setInpageNaviPosition(hash)
  }
}
function setInpageNaviPosition(hash) {
  const mainMenu = document.querySelector(".header-one")
  const voyageMenuWrapper = document.querySelector(".voyage-subnavi-wrapper")
  const anchorMenu = document.querySelector(
    "[data-anchor-menu], [data-anchor-menu-no-filter]"
  )
  var dynamicNaviHeight =
    (mainMenu ? mainMenu.getBoundingClientRect().height : 0) +
    (voyageMenuWrapper ? voyageMenuWrapper.getBoundingClientRect().height : 0) +
    (anchorMenu ? anchorMenu.getBoundingClientRect().height : 0)
  setTimeout(
    function () {
      var id = hash ? hash : this.hash
      if (!id) return
      var scrollElement = document.querySelector(id)
      if (!scrollElement) return
      scrollElement.style.position = "relative"
      scrollElement.style.top = -Math.abs(dynamicNaviHeight) + "px"
      scrollElement.scrollIntoView(true)
    }.call(this),
    100
  )
}
